import React from 'react';
import { Card } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';

/**
 * Error Boundary Component
 * Uygulama hatalarını yakalar ve kullanıcı dostu mesaj gösterir
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
          <Card className="p-8 max-w-lg">
            <div className="flex items-center gap-4 mb-4">
              <AlertTriangle className="w-12 h-12 text-red-500" />
              <div>
                <h2 className="text-2xl font-bold text-red-700">Bir Hata Oluştu</h2>
                <p className="text-sm text-muted-foreground">Beklenmeyen bir sorun oluştu</p>
              </div>
            </div>
            
            <div className="p-4 bg-red-50 rounded-lg border border-red-200 mb-4">
              <p className="text-sm text-red-800 font-mono">
                {this.state.error?.message || 'Bilinmeyen hata'}
              </p>
              {String(this.state.error?.message || '').includes('removeChild') && (
                <p className="text-xs text-red-700 mt-3">
                  Bu hata çoğunlukla tarayıcı çeviri/eklenti müdahalesiyle oluşur. Otomatik çeviriyi ve sayfa içeriğini değiştiren eklentileri kapatıp tekrar deneyin.
                </p>
              )}
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => window.location.reload()}
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Sayfayı Yenile
              </button>
              <button
                onClick={() => window.location.href = '/dashboard'}
                className="flex-1 px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
              >
                Ana Sayfaya Dön
              </button>
            </div>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
